function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 21.6445,
  cy: 21.5469,
  r: 20.75,
  fill: "#EFAE07"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0887 25.527V26.547H12.0967V25.527H13.9687V19.479L12.2287 20.559V19.419L14.4967 18.003H15.2167V25.527H17.0887Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.58 25.527V26.547H18.976V25.623L21.916 22.395C22.292 21.979 22.564 21.603 22.732 21.267C22.908 20.923 22.996 20.583 22.996 20.247C22.996 19.815 22.872 19.487 22.624 19.263C22.376 19.031 22.016 18.915 21.544 18.915C20.752 18.915 19.96 19.227 19.168 19.851L18.724 18.939C19.06 18.627 19.488 18.379 20.008 18.195C20.528 18.003 21.052 17.907 21.58 17.907C22.396 17.907 23.04 18.111 23.512 18.519C23.992 18.927 24.232 19.479 24.232 20.175C24.232 20.671 24.124 21.143 23.908 21.591C23.692 22.031 23.332 22.523 22.828 23.067L20.548 25.527H24.58Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.4433 21.135C29.9793 21.135 30.4473 21.251 30.8473 21.483C31.2553 21.707 31.5673 22.027 31.7833 22.443C32.0073 22.851 32.1193 23.323 32.1193 23.859C32.1193 24.411 31.9953 24.895 31.7473 25.311C31.5073 25.727 31.1593 26.051 30.7033 26.283C30.2473 26.515 29.7153 26.631 29.1073 26.631C28.5793 26.631 28.0593 26.539 27.5473 26.355C27.0353 26.171 26.6113 25.919 26.2753 25.599L26.7073 24.687C27.4993 25.311 28.3033 25.623 29.1193 25.623C29.6873 25.623 30.1273 25.471 30.4393 25.167C30.7593 24.855 30.9193 24.427 30.9193 23.883C30.9193 23.363 30.7593 22.943 30.4393 22.623C30.1273 22.303 29.7073 22.143 29.1793 22.143C28.4113 22.143 27.7953 22.435 27.3313 23.019H26.5273V18.003H31.7593V18.999H27.7513V21.711C28.2073 21.327 28.7713 21.135 29.4433 21.135Z",
  fill: "white"
});

var Svg125 = function Svg125(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg125, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/125.b3412731.svg";
export { ForwardRef as ReactComponent };